import request from '@/config/axios'

export interface ConfigVO {
  id?: number | null
  afterSaleRefundReasons: string[]
  afterSaleReturnReasons: string[]
  deliveryExpressFreeEnabled: boolean
  deliveryExpressFreePrice: number
  deliveryExpressFreeExcludeAreaIds?: number[]
  deliveryPickUpEnabled: boolean
  deliveryPickUpMode?: number
  /** 已支付自提订单超时未核销自动关闭并退款 */
  pickUpVerifyAutoCloseEnabled?: boolean
  /** 自支付成功起算的天数 */
  pickUpVerifyAutoCloseDays?: number
  brokerageEnabled: boolean
  brokerageEnabledCondition?: number
  brokerageBindMode?: number
  brokeragePosterUrls: string[]
  brokerageFirstPercent: number
  brokerageSecondPercent: number
  brokerageWithdrawMinPrice: number
  brokerageWithdrawFeePercent: number
  brokerageFrozenDays: number
  brokerageWithdrawTypes: number[]
  tencentLbsKey?: string
}

// 查询交易中心配置详情
export const getTradeConfig = async () => {
  return await request.get<ConfigVO>({ url: `/trade/config/get` })
}

// 保存交易中心配置
export const saveTradeConfig = async (data: ConfigVO) => {
  return await request.put({ url: `/trade/config/save`, data })
}

// 腾讯地图地点搜索（地点提示）
export interface TencentPlaceSuggestionVO {
  id?: string
  title?: string
  address?: string
  latitude?: number
  longitude?: number
  province?: string
  city?: string
  district?: string
}

export const getTencentPlaceSuggestion = async (keyword: string, region?: string) => {
  return await request.get<TencentPlaceSuggestionVO[]>({
    url: `/trade/config/tencent-place-suggestion`,
    params: { keyword, region }
  })
}
